import { difference } from 'ramda'
import { IDB_filesMeta } from '../IDB/IDB.dexie'
import type { FileId } from '../../../shared/domain/files'

export async function File_getMetasToFetch(requiredFileIds: FileId[]): Promise<FileId[]> {
    const existingFileIds = await IDB_filesMeta()
        .where('fileId')
        .anyOf(requiredFileIds)
        .toArray()
        .then((fms) => fms.map((fm) => fm.fileId))
    return difference(requiredFileIds, existingFileIds)
}
